import { render } from "./ModelPicker.vue?vue&type=template&id=4da46eb4&scoped=true&ts=true"
import script from "./ModelPicker.vue?vue&type=script&lang=ts"
export * from "./ModelPicker.vue?vue&type=script&lang=ts"

import "./ModelPicker.vue?vue&type=style&index=0&id=4da46eb4&lang=scss&scoped=true"

import exportComponent from "/builds/arkindex/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4da46eb4"]])

export default __exports__